import { render, staticRenderFns } from "./xhqSendContainerDialog.vue?vue&type=template&id=712f6c56&"
import script from "./xhqSendContainerDialog.vue?vue&type=script&lang=js&"
export * from "./xhqSendContainerDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('712f6c56')) {
      api.createRecord('712f6c56', component.options)
    } else {
      api.reload('712f6c56', component.options)
    }
    module.hot.accept("./xhqSendContainerDialog.vue?vue&type=template&id=712f6c56&", function () {
      api.rerender('712f6c56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/xhqSendContainerDialog.vue"
export default component.exports